// Utilitário para extrair número do DOM
function getValorFromDom(id) {
  const el = document.querySelector(`#${id}`);
  return el ? parseFloat(el.innerText.replace(",", ".")) || null : null;
}

// Somar dias úteis para entrega
function calcularDataEntrega(prazoDias) {
  const data = new Date();
  let diasAdicionados = 0;
  while (diasAdicionados < prazoDias) {
    data.setDate(data.getDate() + 1);
    const dia = data.getDay();
    if (dia !== 0 && dia !== 6) diasAdicionados++;
  }
  return data.toLocaleDateString("pt-BR", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

function initFreteCalculo() {
  const endpointFrete = "https://stackhaus.com.br/frete/api/frete";
  const botaoCalcular = document.querySelector("#btn-calcular-frete");
  const cepInput = document.querySelector("#cep");
  const resultado = document.querySelector("#resultado-frete");

  // Máscara de CEP + limpeza de resultado
  cepInput.addEventListener("input", () => {
    let valor = cepInput.value.replace(/\D/g, "");
  
    if (valor.length === 0) {
      resultado.innerHTML = "";
    }
  
    cepInput.value =
      valor.length <= 5
        ? valor
        : valor.slice(0, 5) + "-" + valor.slice(5, 8);
  });
  
  // Buscar carrinho e variantes dos produtos
  async function obterProdutosDoCarrinho() {
    const cart = await fetch("/cart.js").then((res) => res.json());
  
    const produtos = await Promise.all(
      cart.items.map(async (item) => {
        try {
          const res = await fetch(`/products/${item.handle}.js`);
          const produto = await res.json();
          const variante = produto.variants.find((v) => v.id === item.variant_id);
  
          const preco = (variante?.price || item.final_price) / 100;
          const peso = (variante?.weight || 200) / 1000; // Peso real da variante ou 0.2kg
  
          const altura =
            getValorFromDom("PRODUCTVARIANT.metafields.frenet.altura-anchor") || 2;
          const largura =
            getValorFromDom("PRODUCTVARIANT.metafields.frenet.largura-anchor") || 11;
          const comprimento =
            getValorFromDom("PRODUCTVARIANT.metafields.frenet.comprimento-anchor") || 16;
  
          return {
            peso,
            largura,
            altura,
            comprimento,
            quantidade: item.quantity,
            preco,
          };
        } catch (e) {
          console.error("Erro ao buscar item do carrinho", e);
          return null;
        }
      })
    );
  
    return produtos.filter((p) => p !== null);
  }
  
  // Clique no botão de calcular frete
  botaoCalcular?.addEventListener("click", async () => {
    const cep = cepInput.value.replace(/\D/g, "");
    if (cep.length !== 8) {
      resultado.innerHTML = '<div style="color:red">CEP inválido</div>';
      return;
    }
  
    resultado.innerHTML = "Calculando frete...";
  
    try {
      const produtos = await obterProdutosDoCarrinho();
  
      const res = await fetch(endpointFrete, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shop-Domain": window.location.hostname
        },
        body: JSON.stringify({ cep, produtos }),
      });
  
      const data = await res.json();
      const fretes = data.fretes || [];
  
      if (fretes.length === 0) {
        resultado.innerHTML = `<div style="color:red">Nenhum frete disponível para ${cep}</div>`;
        return;
      }
  
      // Ordenar por prazo crescente
      fretes.sort((a, b) => {
        const diasA = parseInt(a.prazo.match(/\d+/)?.[0] || 999);
        const diasB = parseInt(b.prazo.match(/\d+/)?.[0] || 999);
        return diasA - diasB;
      });
  
      // Exibir resultados
      resultado.innerHTML = `
        <div style="margin-top:13px;width: 95%;max-width: 100%;">
          ${fretes
            .map((f) => {
              const dias = parseInt(f.prazo.match(/\d+/)?.[0] || 0);
              const dataEntrega = calcularDataEntrega(dias);
              return `
              <li style="margin-bottom: 10px;display: flex;align-items: flex-start;flex-wrap: wrap;text-decoration: dotted;font-size: 13.5px;">
                <span>${f.nome} - Prazo de entrega até <strong>${dataEntrega}</strong><br></span>
                <strong>R$ ${parseFloat(f.valor).toFixed(2).replace(".", ",")}</strong>
              </li>`;
            })
            .join("")}
        </div>
      `;
    } catch (err) {
      console.error("Erro ao calcular frete:", err);
      resultado.innerHTML = '<div style="color:red">Erro ao calcular frete</div>';
    }
  });
}

// Executar na primeira carga
initFreteCalculo();

// Evita erro ao redeclarar
window.__freteObserver__?.disconnect();

window.__freteObserver__ = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (
      mutation.type === "childList" &&
      document.querySelector("#btn-calcular-frete")
    ) {
      initFreteCalculo();
    }
  });
});

const target = document.querySelector("#CartDrawer");

if (target) {
  window.__freteObserver__.observe(target, {
    childList: true,
    subtree: true,
  });
}



